import React from "react";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
    const jwt = localStorage.getItem("jwt");

    if (jwt) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AuthRoute;

